import { render } from "./Start.vue?vue&type=template&id=152385c9"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import exportComponent from "E:\\backup\\Programowanie\\kurs\\vue\\siatka-koncentracji\\siatka-koncentracji\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__